/**
 * @fileoverview Agent definition for portrait-image-creator-fal-v2.
 *
 * This agent generates a portrait image from a detailed prompt
 * using the fal.ai provider for high-quality image generation.
 *
 * @category visuals.images.characters
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'portrait-image-creator-fal-v2',
  kind: 'primitive',
  name: 'Portrait Image Creator (FAL)',
  description: 'Generates a portrait image from a detailed prompt using the fal.ai provider.',
  category: 'visuals',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-01',
    lastUpdated: '2026-01',
    taxonomyPath: 'visuals.images.characters',
    usedBy: [
      'use-portrait-generation-fal-v2.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'portrait-prompt-creator-v2',
      'character-image-creator-fal-v2',
    ],
  },
};
